// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".listing-img[data-v-31d65a13]{position:relative;overflow:hidden}.listing-img img[data-v-31d65a13],.slide-images img[data-v-31d65a13]{width:100%;height:220px;-o-object-fit:cover;object-fit:cover;border-radius:8px}.list-rating[data-v-31d65a13]{display:flex;align-items:center;gap:3px}.list-rating span[data-v-31d65a13]{margin-left:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
